<div style="margin-top: 10px;">
    <span style="font-weight: bold;">Server Settings</span>
    <div class="form-check server-setting-checkbox">
        <input class="form-check-input" type="checkbox" id="drop-discovery-results"
            [(ngModel)]="settings.drop_discovery_results" (change)="saveServerSettings()">
        <label class="form-check-label" for="drop-discovery-results">
            Drop Discovery Results
        </label>
        <span style="padding-left: 5px;">&nbsp;</span>
        <info width="300px">Discard discovery results posted by agents.</info>
    </div>
    <div class="form-check server-setting-checkbox">
        <input class="form-check-input" type="checkbox" id="drop-monitor-data" [(ngModel)]="settings.drop_monitor_data"
            (change)="saveServerSettings()">
        <label class="form-check-label" for="drop-monitor-data">
            Drop Monitor Data
        </label>
        <span style="padding-left: 5px;">&nbsp;</span>
        <info width="300px">Discard monitor data posted by agents.</info>
    </div>
    <div class="form-check server-setting-checkbox">
        <input class="form-check-input" type="checkbox" id="disable-agent-auto-update"
            [(ngModel)]="settings.disable_agent_auto_update" (change)="saveServerSettings()">
        <label class="form-check-label" for="disable-agent-auto-update">
            Disable Agent Auto Update
        </label>
        <span style="padding-left: 5px;">&nbsp;</span>
        <info width="300px">Disable automatic updates for agents.</info>
    </div>
</div>